import { useContext, useState } from "react"
import { ButtonSpinner, encodedText, initialFormState, PasswordShow, validateForm } from "../../../components/CommonMethod"
import { Link, useNavigate } from "react-router-dom"
import { ENCRYPTED_KEY, fetchData, USER_CREATE } from "../../../components/Service"
import { Context } from "../../../components/Context"


const SignUpModal = () => {
    const navigate = useNavigate();
    const [, setContext] = useContext(Context);
    const [tinyloader, setTinyloader] = useState(false)

    const register = (e) => {
        let formData = new FormData(document.getElementById('signUpForm'));
        if (validateForm(e, 'signUpForm')) {
            setTinyloader(true);

            fetchData(USER_CREATE, 'POST', formData, false, true, (res) => {
                setTinyloader(false);

                if (res.records) {
                    initialFormState('signUpForm')
                    document.querySelector('#signUpModalForm .btn-close').click();
                    localStorage.setItem('waae-token', res.records.access_token);
                    setContext(prevState => ({ ...prevState, auth: res.records }));
                    navigate(`/shop-details/${encodedText({ id: 'all' }, ENCRYPTED_KEY)}`);
                }
            }, '', false, 'signUpForm');
        }
    }

    return (
        <div className="modal fade" id="signUpModalForm" data-bs-backdrop="static" tabIndex="-1">
            <div className="modal-dialog">
                <form className="modal-content border border-2 border-blue p-2 rounded-4 needs-validation" id="signUpForm" noValidate autoComplete='off'>
                    <div className="modal-header border-0">
                        <h3 className="modal-title fw-bold text-blue">User Registation</h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-2">
                            <div className="mb-3">
                                <div className="form-floating">
                                    <input type="hidden" name="age_group" id="age_group" defaultValue="0" />
                                    <input type="hidden" name="instant_register" id="instant_register" defaultValue="instant_register" />
                                    <input type="text" name="first_name" id="first_name" className="form-control form-control-md" placeholder="First name" defaultValue="" required />
                                    <div className="invalid-feedback">
                                        The first name field is required.
                                    </div>
                                    <label>First name <span className="text-danger">*</span></label>
                                </div>
                            </div>
                            <div className="mb-3">
                                <div className="form-floating">
                                    <input type="text" name="last_name" id="last_name" className="form-control form-control-md" placeholder="Last name" defaultValue="" required />
                                    <div className="invalid-feedback">
                                        The last name field is required.
                                    </div>
                                    <label>Last name <span className="text-danger">*</span></label>
                                </div>
                            </div>
                            <div className="mb-3">
                                <div className="form-floating">
                                    <input type="email" name="email" id="email" className="form-control form-control-md" placeholder="Email address" defaultValue={''} required />
                                    <div className="invalid-feedback">
                                        The email field is required.
                                    </div>
                                    <label>Email address <span className="text-danger">*</span></label>
                                </div>
                            </div>
                            <div className="mb-3">
                                <div className="form-floating password-wrapper">
                                    <input type="password" name="password" placeholder="Password" id="password" className="form-control form-control-md" defaultValue="" required autocomplete="new-password" />
                                    <div className="invalid-feedback position-absolute">
                                        The password field is required.
                                    </div>
                                    <div><button type="button" className="btn eye-btn" onClick={(e) => PasswordShow(e, 'password')}>
                                        <svg className="icon pe-none"><use href="#icon_eye"></use></svg>
                                    </button></div>
                                    <label>Password <span className="text-danger" id="required_attr">*</span></label>
                                </div>
                            </div>
                            <div className="checkbox_agree_condition mb-4 ">
                                <label className="form-check form-check-custom ">
                                    <input className="form-check-input privacy-check" type="checkbox" value="" required />
                                    <div className="form-check-label fw-bold privacy-check">I agree with We are all Elemental's
                                        <Link to="/terms-of-use" className="ps-1">Terms of use</Link> and <Link to="/privacy-policy" className="ps-1">Privacy policy</Link></div>
                                    <div className="invalid-feedback position-absolute">
                                        You must agree before submitting.
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="modal-footer border-0">
                        <button type="button" className="btn btn-theme-primary btn-lg minw-110 mb-3 mb-sm-2 me-auto me-sm-0 order-sm-1" onClick={(e) => register(e)} disabled={tinyloader}>
                            <ButtonSpinner load={tinyloader} btnName="Register" />
                        </button>
                    </div>

                </form>
            </div>
        </div>
    )
}

export default SignUpModal